module.exports = __webpack_public_path__ + "static/media/icon-piece.bee6c6fb.svg";